import type { CarouselNavigatePayload } from '@noths/polaris-design-system-candidate-components';

import { sendProductReviewsEvent } from 'src/tracking/sendProductReviewsEvent';

/** The photo's 1-based position in the strip, so which ones get clicked can be read off. */
export const trackCustomerPhotoClick = (index: number) =>
  sendProductReviewsEvent('Customer photo click', String(index + 1));

export const trackCustomersPhotosImpression = () =>
  sendProductReviewsEvent('Customers photos impression', 'not set');

/** Once per settled movement, whether by arrow or by swipe, since the two are tracked apart. */
export const trackCustomersPhotosNavigate = ({ direction, method }: CarouselNavigatePayload) =>
  sendProductReviewsEvent('Customers photos navigate', `${method} ${direction}`);
